import { render, staticRenderFns } from "./CropHarvestQualityCard.vue?vue&type=template&id=bc017978&scoped=true&lang=html&"
import script from "./CropHarvestQualityCard.vue?vue&type=script&lang=js&"
export * from "./CropHarvestQualityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc017978",
  null
  
)

export default component.exports